<template>
	<div id="ntrance">
		<meta name="viewport"
			content="width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0,user-scalable=no" />
		<div class="popContainer" v-show="selOrder">
			<div class="shuaiqi">
				<div class="transition-four" @click.stop>
					<div style="margin-top: 0.9375rem;font-size: 0.8125rem;font-weight: bold;">订单查询</div>
					<input v-model="studyName" class="inpForm" placeholder='请输入姓名' />
					<input v-model="studyNo" class="inpForm" placeholder='请输入手机号' />
					<div class="btnTransition" @click="btnPayOrder()">查询</div>
				</div>
			</div>
		</div>
		<div class="item" v-if="xian == 2" v-for="(item, index) in orderDetail" :key="index">
			<div class="item_tit">
				<img class="tit_icon" src="copy.png" alt="丢了" />
				{{ item.template_title }}
			</div>

			<div class="line"></div>
			<div class="item_s">
				<div class="left">收款单位</div>
				<div class="right">{{ item.store_name }}</div>
			</div>
			<div class="item_s">
				<div class="left">缴费人姓名</div>
				<div class="right">{{ item.name }}</div>
			</div>
			<div class="item_s" v-if="store_type !== 6">
				<div class="left">缴费人学号</div>
				<div class="right">{{ item.student_code }}</div>
			</div>
			<div class="item_s" v-if="store_type == 6">
				<div class="left">缴费人手机号</div>
				<div class="right">{{ item.phone }}</div>
			</div>

			<div class="item_s">
				<div class="left">缴费事项</div>
				<div class="right">
					{{ item.payment_event }}
				</div>
			</div>
			<div class="item_s" v-if="store_type == 6">
				<div class="left">批次说明</div>
				<div class="right">
					{{ item.introduce }}
				</div>
			</div>

			<div class="item_s" v-if="store_type !== 6">
				<div class="left">助学贷款</div>
				<div class="right">{{ item.need_money }}</div>
			</div>
			<div class="item_s">
				<div class="left">缴费时间</div>
				<div class="right">{{ item.pay_time }}</div>
			</div>
			<div class="item_s">
				<div class="left">应缴金额</div>
				<div class="right">{{ item.content_money }}</div>
			</div>
			<div class="item_s">
				<div class="left">实缴金额</div>
				<div class="right">{{ item.money }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import {
	Dialog
} from 'vant';
export default {

	name: "Entrance",

	data() {
		return {
			orderDetail: [],
			studyName: '',//刘先生
			studyNo: '',//18990900913
			selOrder: true,
			xian: 1,
			store_type:'',
		};
	},
	components: {},
	methods: {
		btnPayOrder() {
			if (this.studyName !== '' && this.studyNo !== '') {
				this.$request.customOrder({
					template_id: this.$storage.getLocal('template_id'),
					studyName: this.studyName,
					student_code: this.studyNo,
				}).then(res => {
					console.log(res)
					if (res.code == 1) {
						this.xian = 2
						this.selOrder = false
						this.orderDetail = res.data
					} else {
						Dialog.alert({
							message: "请您输入正确的查询信息,重新查询",
						}).then((res) => {

						});
					}
				})

			} else {
				Dialog.alert({
					message: "请您输入正确的查询信息,重新查询",
				}).then((res) => {

				})
			}

		},
		getType() {
			this.$request.judgeTemplateStatus({
				template_id: this.$storage.getLocal('template_id')
			}).then(res => {
				if (res.code !== 0) {
					this.store_type = res.data.type
				} else {
					Dialog.alert({
						message: "该订单已失效",
					}).then((res) => {
						window.close()
					});
				}
			})
		},
	},
	created() {
		this.getType();

		console.log(this.$route.query.schOnly)

	},
	beforeCreate() { },
	mounted() { },
	destroyed() { },
};
</script>

<style scoped>
#ntrance {
	width: 100vw;
	height: 100vh;
	background: #f3f3f3;
	overflow: auto;
}

.item {
	width: 91%;
	/* height: 15.625rem; */
	border: 1px solid white;
	line-height: 1.25rem;
	padding-bottom: 0.125rem;
	padding-top: 0.125rem;
	background: #fff;
	margin: 30px auto;
	border-radius: 10px;
}

.item>div {
	width: 91%;
}

.item_tit {
	font-size: 0.9375rem;
	font-weight: bold;
	margin: 0 auto;
	margin-top: 16px;
}

.tit_icon {
	width: 18px;
	height: 18px;
	/* border: 1px solid black; */
	vertical-align: middle;
	margin-top: -5px;
}

.line {
	height: 1px;
	background: #dddddd;
	margin: 0 auto;
	margin-top: 13px;
}

.item_s {
	/* border: 1px solid red; */
	display: flex;
	justify-content: space-between;
	margin: 11px auto;
	font-size: 0.75rem;
}

.left {
	width: 40%;
	color: #666666;
}

.right {
	text-align: right;
	width: 70%;
}

.inpForm {
	width: 75%;
	height: 1.75rem;
	border: none;
	margin-top: 0.9375rem;
	padding-left: 0.9375rem;
	background: #F7F7F7;
	font-size: 0.8125rem;
	border-radius: 1.5625rem;
}

.shuaiqi {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}

.btnTransition {
	margin-top: 0.9375rem;
	width: 84%;
	height: 2rem;
	margin-left: 8%;
	margin-bottom: 0.9375rem;
	border-radius: 1.5625rem;
	background-color: #DD0B0D;
	line-height: 2rem;
	color: white;
}

.popContainer {
	z-index: 3;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.3);
}

.transition-four {
	width: 80%;
	text-align: center;
	border-radius: 10px;
	z-index: 2;
	top: 100px;
	left: 10%;
	box-shadow: 0px 0px 10px #888888;
	background-color: #fff;
	box-sizing: border-box;
	overflow-y: auto;
}
</style>
